import { Box } from '@mui/material';
import { CreditsItemRoute, CreditsRoute } from '../../routes/allRoutes';
import { ServiceItemView } from '../serviceItemView/serviceItemView';
import { BreadcrumbsBar } from '../breadcrumbs/breadcrumbsBar';
import { appStyleMode } from '../../helpers/clientConfigs';
import { AppStyle } from '../../helpers/appStyle';
import { useServiceItem } from '../../hooks/useServiceItem';

export function CreditsItem() {
  const service = useServiceItem('credits');

  return (
    <Box sx={{ mt: appStyleMode === AppStyle.Mobile ? '0px' : '10px' }}>
      <BreadcrumbsBar
        paths={[
          { path: CreditsRoute, isLink: true },
          { path: CreditsItemRoute, title: service?.name },
        ]}
      />
      <ServiceItemView service={service} actionType="buyCredits" />
    </Box>
  );
}
